//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { map, filter, isUndefined, isEmpty } from 'lodash'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { accountActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import {
	FormInfoWrapper,
	InputWrapper,
	InputLogin,
	SelectInput,
	SelectInputWrapper,
	ErrorInputMsg,
	LabelText,
	PageWrapperPart,
	PageWrapperPartHandler,
	PageWrapperActions,
	PageWrapperActionReset,
	PageWrapperActionValidate,
} from '../../theme/GlobalCss'
import TooltipHelp from '../../components/TooltipHelp'
import Tooltip from '../../components/Tooltip/Tooltip'
//////ASSETS//////
import LabelIcon from '../../assets/icones/global/thumb-black.svg'
import CloseRed from '../../assets/icones/global/close-red.svg'

//////STYLED//////
const UsersManagerDetailWrapper = styled.form`
	position: relative;
`
const LabelTextTag = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > *:first-child {
		margin-right: 10px;
		width: 120px;
	}
`
const TagList = styled.span`
	font-style: italic;
`
const ErrorBox = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	max-width: 420px;
	background: #f5d7d7;
	border: 1px solid #f2c2c2;
	border-radius: 5px;
	margin-top: 5%;
`
const ErrorMessageWrapper = styled.div`
	height: auto;
	max-width: 100%;
	display: flex;
	flex-direction: row;
	margin: 3%;
`
const ErrorMessageImg = styled.img`
	height: auto;
	width: auto;
	margin-left: 2%;
	margin-top: 1%;
	display: flex;
	align-self: flex-start;
`
const ErrorMessageText = styled.div`
	height: auto;
	width: 100%;
	margin-left: 4%;
	color: ${(props) => props.theme.colors.error};
`
const PrivateTagIcon = styled.img`
	height: 15px;
	width: 15px;
	margin-right: 5px;
`
const TagsWrapperContent = styled.div`
	display: flex;
	flex-direction: row;
	& > * {
		margin: 0 2px;
	}
`
const TagListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 22px;
	overflow-y: auto;
	height: 100%;
`
const FormInfoWrapperAccountTag = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: max-content 1fr;
	grid-column-gap: 20px;
	grid-row-gap: 20px;
	align-items: center;
	color: ${(props) => props.theme.colors.menu.link};
	box-sizing: border-box;
`
const FormInfoWrapperAccountMachine = styled.div`
	height: 60vh;
	position: relative;
	display: grid;
	grid-template-columns: max-content 1fr;
	grid-column-gap: 20px;
	grid-row-gap: 20px;
	align-items: flex-start;
	color: ${(props) => props.theme.colors.menu.link};
	box-sizing: border-box;
`
const TagListAccount = styled.span`
	font-style: italic;
	margin-bottom: 22px;
`

const LabelPrivateTagWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`
//////STYLED//////

const MyAccount = (props) => {
	let history = useHistory()

	const [stateDefaultValues, setStateDefaultValues] = useState()

	const { translations, languagesList, myAccount } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			languagesList: state.languages.items,
			myAccount: state.myAccount,
		}),
		shallowEqual
	)

	const actionsAccountManager = bindActionCreators(accountActionCreators, useDispatch())

	const getMyAccount = () => {
		// Is used to set roles, which should change later
		actionsAccountManager.getAccount()
	}

	const handleRedirect = () => {
		history.push(`${uriList.users}${uriList.usersManager}`)
	}
	const onSubmit = (data) => {
		actionsAccountManager.updateAccount(data)
	}

	const { register, handleSubmit, watch, errors, setValue, reset, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (isEmpty(translations)) return
		getMyAccount()
	}, [translations])

	useEffect(() => {
		if (!isEmpty(myAccount.items)) {
			setValue('lastName', myAccount.items.lastName)
			setValue('firstName', myAccount.items.firstName)
			setValue('idPreferedLanguage', myAccount.items.preferedLanguage.id)
			setValue('phoneNumber', myAccount.items.phoneNumber)
			setValue('email', myAccount.items.email)
			setValue('company', myAccount.items.companyLabel)
			setValue('division', translations[myAccount.items.companyTypedLabel])
			setValue('service', myAccount.items.service)
			setValue('idRole', myAccount.items.role.label)
			setValue('identifiant', myAccount.items.userName)
			setStateDefaultValues(getValues)
		}
	}, [myAccount.items, translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<UsersManagerDetailWrapper onSubmit={handleSubmit(onSubmit)}>
				<PageWrapperActions>
					<Tooltip tooltipId={'myAccountSubmit'} translationsKey={'tooltip__admin__global__save'}>
						<PageWrapperActionValidate unlocked type={'submit'} />
					</Tooltip>
					<Tooltip tooltipId={'myAccountReset'} translationsKey={'tooltip__admin__global__reset'}>
						<PageWrapperActionReset onClick={() => reset(stateDefaultValues)} />
					</Tooltip>
				</PageWrapperActions>
				<PageWrapperPartHandler>
					<PageWrapperPart>
						<FormInfoWrapper password>
							<LabelText>
								{/* Langue par défaut : */}
								{translations['page__userDetail__admin__userSheet_form_defaultLanguage']}* :
							</LabelText>

							<InputWrapper>
								<SelectInputWrapper>
									<SelectInput
										width="208"
										name="idPreferedLanguage"
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
									>
										{map(languagesList, (elem, id) => {
											return (
												<option key={id} value={elem.id}>
													{elem.labelEnglish}
												</option>
											)
										})}
									</SelectInput>
								</SelectInputWrapper>
								{errors?.idPreferredLanguage?.type === 'required' && (
									<ErrorInputMsg>{errors?.idPreferredLanguage.message}</ErrorInputMsg>
								)}
							</InputWrapper>

							<LabelText>
								{/* Nom : */}
								{translations['page__userDetail__admin__userSheet_form_lastname']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="lastName"
									type="text"
									// placeholder="Nom"
									placeholder={translations['page__userDetail__admin__userSheet_form_lastname_prefilled']}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: `${translations['page__userDetail__admin__userSheet_form_lastname']} 150 ${translations['common__text__charMax']}`,
										},
									})}
								/>
								{errors?.lastName?.type === 'required' && <ErrorInputMsg>{errors?.lastName.message}</ErrorInputMsg>}
							</InputWrapper>

							<LabelText>
								{/* Prénom : */}
								{translations['page__userDetail__admin__userSheet_form_firstname']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="firstName"
									type="text"
									placeholder={translations['page__userDetail__admin__userSheet_form_firstname_prefilled']}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: `${translations['page__userDetail__admin__userSheet_form_firstname']} 150 ${translations['common__text__charMax']}`,
										},
									})}
								/>
								{errors?.firstName?.type === 'required' && <ErrorInputMsg>{errors?.firstName.message}</ErrorInputMsg>}
							</InputWrapper>
							<TooltipHelp content={'tooltipHelp__admin__modal__body__userPreference__SMS'} childrenPos={1}>
								<LabelText>
									{/* Téléphone : */}
									{translations['page__userDetail__admin__userSheet_form_phone']} :
								</LabelText>
							</TooltipHelp>
							<InputWrapper>
								<InputLogin
									name="phoneNumber"
									type="tel"
									placeholder={translations['page__userDetail__admin__userSheet_form_phone_prefilled']}
									ref={register({
										required: {
											value: false,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 10,
											message: `${translations['page__userDetail__admin__userSheet_form_phone']} 10 ${translations['common__text__charMax']}`,
										},
									})}
								/>
								{errors?.phoneNumber?.type === 'required' && <ErrorInputMsg>{errors?.phoneNumber.message}</ErrorInputMsg>}
							</InputWrapper>
							<LabelText>
								{/* Email : */}
								{translations['page__userDetail__admin__userSheet_form_email']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									type="text"
									name="email"
									placeholder={translations['page__userDetail__admin__userSheet_form_email_prefilled']}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: `${translations['page__userDetail__admin__userSheet_form_email_prefilled']} 150 ${translations['common__text__charMax']}`,
										},
										pattern: {
											value: RegExp(
												/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
											),
											message: translations['common__text__invalidEmail'],
										},
									})}
								/>
								{errors?.email?.type === 'required' && <ErrorInputMsg>{errors?.email.message}</ErrorInputMsg>}
							</InputWrapper>

							<LabelText>
								{/* Nouveau mot de passe : */}
								<TooltipHelp content={'tooltipHelp__admin__modal__body__myAccount__newPassword'} childrenPos={1}>
									{translations['page__userDetail__userSheet_form_newPassword']} :
								</TooltipHelp>
							</LabelText>
							<InputWrapper>
								<InputLogin
									type="password"
									name="newPassword"
									placeholder={translations['page__userDetail__userSheet_form_newPassword_prefilled']}
									ref={register({
										required: {
											value: !!watch('oldPassword'),
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: `${translations['page__userDetail__userSheet_form_newPassword_prefilled']} 150 ${translations['common__text__charMax']}`,
										},
										pattern: {
											value: RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/),
											message: translations['page__userDetail__admin__userSheet_form_passwordRestriction'],
										},
									})}
								/>
								{errors?.newPassword?.type === 'required' && <ErrorInputMsg>{errors?.newPassword.message}</ErrorInputMsg>}
							</InputWrapper>

							{!!watch('newPassword') && (
								<>
									<LabelText>
										{/* Confirme nouveau mot de passe : */}
										{translations['page__userDetail__userSheet_form_newPassword2']} :
									</LabelText>
									<InputWrapper>
										<InputLogin
											type="password"
											name="confirmNewPassword"
											placeholder={translations['page__userDetail__admin__userSheet_form_newPassword2']}
											ref={register({
												validate: (value) =>
													value !== watch('newPassword')
														? translations['page__userDetail__admin__userSheet_form_passwordMatch']
														: true,
												required: {
													value: !!watch('oldPassword'),
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 150,
													message: `${translations['page__userDetail__admin__userSheet_form_newPassword2']} 150 ${translations['common__text__charMax']}`,
												},
											})}
										/>
										{errors?.confirmNewPassword?.type === 'required' && (
											<ErrorInputMsg>{errors?.confirmNewPassword.message}</ErrorInputMsg>
										)}
									</InputWrapper>

									<LabelText>
										{/* Ancien mot de passe : */}
										{translations['page__userDetail__userSheet_form_oldPassword']} :
									</LabelText>
									<InputWrapper>
										<InputLogin
											type="password"
											name="oldPassword"
											placeholder={translations['page__userDetail__userSheet_form_oldPassword_prefilled']}
											ref={register({
												required: {
													value: !!watch('newPassword'),
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 150,
													message: `${translations['page__userDetail__userSheet_form_oldPassword']} 150 ${translations['common__text__charMax']}`,
												},
											})}
										/>
										{errors?.oldPassword?.type === 'required' && <ErrorInputMsg>{errors?.oldPassword.message}</ErrorInputMsg>}
									</InputWrapper>
								</>
							)}
						</FormInfoWrapper>

						{!isEmpty(filter(errors, (error) => error.type !== 'required' && error.message !== '')) && !isEmpty(errors) && (
							<ErrorBox>
								{map(
									errors,
									(error, id) =>
										error.type !== 'required' &&
										error.message !== '' && (
											<ErrorMessageWrapper key={id}>
												<ErrorMessageImg src={CloseRed} />
												<ErrorMessageText> {error.message} </ErrorMessageText>
											</ErrorMessageWrapper>
										)
								)}
							</ErrorBox>
						)}
					</PageWrapperPart>

					{/************************* 2eme COLONNE ***********************/}

					<PageWrapperPart>
						<FormInfoWrapper>
							<LabelText>
								{/* Société : */}
								{translations['page__userDetail__admin__userSheet_form_company']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									type="text"
									name="company"
									placeholder={translations['page__userDetail__admin__userSheet_form_company']}
									disabled={true}
									ref={register({
										required: {
											value: true,
										},
										maxLength: {
											value: 150,
											message: `150 ${translations['common__text__charMax']}`,
										},
									})}
								/>
							</InputWrapper>
							<LabelText>
								{/* Division : */}
								{translations['page__userDetail__admin__userSheet_form_division']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="division"
									type="text"
									placeholder={translations['page__userDetail__admin__userSheet_form_division']}
									disabled={true}
									ref={register({
										required: {
											value: true,
										},
									})}
								/>
							</InputWrapper>
							<LabelText>
								{/* Service : */}
								{translations['page__userDetail__userSheet_form_service']} :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="service"
									type="text"
									placeholder={translations['page__userDetail__userSheet_form_service_doubleDot']}
									disabled={true}
									ref={register()}
								/>
							</InputWrapper>
							<LabelText>
								{/* Rôle : */}
								{translations['page__userDetail__admin__userSheet_form_role']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="idRole"
									type="text"
									placeholder={translations['page__userDetail__admin__userSheet_form_role']}
									disabled={true}
									ref={register({
										required: {
											value: true,
										},
									})}
								/>
							</InputWrapper>
							<LabelText>
								{/* Identifiant : */}
								{translations['page__userDetail__admin__userSheet_form_login']}* :
							</LabelText>
							<InputWrapper>
								<InputLogin
									name="identifiant"
									type="text"
									placeholder={translations['page__userDetail__admin__userSheet_form_login']}
									disabled={true}
									ref={register({
										required: {
											value: true,
										},
									})}
								/>
							</InputWrapper>
						</FormInfoWrapper>
					</PageWrapperPart>

					{/************************* 3eme COLONNE ***********************/}

					{!isUndefined(myAccount.items.publicTags) && !isUndefined(myAccount.items.privateTags) && (
						<PageWrapperPart>
							<FormInfoWrapperAccountTag>
								<TagsWrapperContent>
									<TooltipHelp content={'tooltipHelp__admin__modal__body__myAccount__publicTag'} childrenPos={2}>
										<LabelText>{translations['page__userDetail__userSheet_form_public_tag']} :</LabelText>
									</TooltipHelp>
									{/* <QuestionMarkWrapper src={ QuestionMark }/> */}
								</TagsWrapperContent>

								<TagList>
									{!isEmpty(myAccount.items.publicTags)
										? map(myAccount.items.publicTags, 'name').join(' | ')
										: translations['page__userDetail__admin__userSheet_form_empty_tag']}
								</TagList>
								<TagsWrapperContent>
									<TooltipHelp content={'tooltipHelp__admin__modal__body__myAccount__privateTag'} childrenPos={2}>
										<LabelPrivateTagWrapper>
											<PrivateTagIcon src={LabelIcon} />
											<LabelText>{translations['page__userDetail__userSheet_form_private_tag']} :</LabelText>
										</LabelPrivateTagWrapper>
									</TooltipHelp>
									{/* <QuestionMarkWrapper src={ QuestionMark }/> */}
								</TagsWrapperContent>

								<TagList>
									{!isEmpty(myAccount.items.privateTags)
										? map(myAccount.items.privateTags, 'name').join(' | ')
										: translations['page__userDetail__admin__userSheet_form_empty_tag']}
								</TagList>
							</FormInfoWrapperAccountTag>
						</PageWrapperPart>
					)}

					{/************************* 4eme COLONNE ***********************/}

					<PageWrapperPart>
						<FormInfoWrapperAccountMachine>
							<LabelTextTag>
								<LabelText>{translations['page__userDetail__admin__userSheet_form_userKiosk_access']} :</LabelText>
							</LabelTextTag>
							<TagListWrapper>
								{map(myAccount.items.kioskList, (kiosk, id) => (
									<TagListAccount key={id}>{kiosk.kioskName}</TagListAccount>
								))}
							</TagListWrapper>
						</FormInfoWrapperAccountMachine>
					</PageWrapperPart>
				</PageWrapperPartHandler>
			</UsersManagerDetailWrapper>
		</Fragment>
	)
}

MyAccount.propTypes = {}

MyAccount.defaultPropTypes = {}

export default MyAccount
